import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 *
 * The shadowDom / Intersection Observer version of Paul's concept:
 * https://github.com/paulirish/lite-youtube-embed
 *
 * A lightweight YouTube embed. Still should feel the same to the user, just
 * MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these (👍👍):
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube
 *   https://github.com/Daugilas/lazyYT https://github.com/vb/lazyframe
 */

/*
 * Vimeo example embed markup:
<iframe src="https://player.vimeo.com/video/364402896"
  width="640" height="360"
  frameborder="0"
  allow="autoplay; fullscreen" allowfullscreen>
</iframe>
<p><a href="https://vimeo.com/364402896">
  Alex Russell - The Mobile Web: MIA</a> from
    <a href="https://vimeo.com/fronteers">Fronteers</a>
    on <a href="https://vimeo.com">Vimeo</a>.
</p>
 */
var LiteVimeoEmbed =
/** @class */
function () {
  var LiteVimeoEmbed = /*#__PURE__*/function (_HTMLElement) {
    _inherits(LiteVimeoEmbed, _HTMLElement);

    var _super = _createSuper(LiteVimeoEmbed);

    function LiteVimeoEmbed() {
      var _this;

      _classCallCheck(this, LiteVimeoEmbed);

      _this = _super.call(this);
      _this.iframeLoaded = false;

      _this.setupDom();

      return _this;
    }

    _createClass(LiteVimeoEmbed, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;

        this.addEventListener('pointerover', LiteVimeoEmbed.warmConnections, {
          once: true
        });
        this.addEventListener('click', function () {
          return _this2.addIframe();
        });
      }
    }, {
      key: "setupDom",

      /**
       * Define our shadowDOM for the component
       */
      value: function setupDom() {
        var shadowDom = this.attachShadow({
          mode: 'open'
        });
        shadowDom.innerHTML = "\n      <style>\n        :host {\n          contain: content;\n          display: block;\n          position: relative;\n          width: 100%;\n          padding-bottom: calc(100% / (16 / 9));\n        }\n\n        #frame, #fallbackPlaceholder, iframe {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n        }\n\n        #frame {\n          cursor: pointer;\n        }\n\n        #fallbackPlaceholder {\n          object-fit: cover;\n        }\n\n        #frame::before {\n          content: '';\n          display: block;\n          position: absolute;\n          top: 0;\n          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==);\n          background-position: top;\n          background-repeat: repeat-x;\n          height: 60px;\n          padding-bottom: 50px;\n          width: 100%;\n          transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n          z-index: 1;\n        }\n        /* play button */\n        .lvo-playbtn {\n          width: 70px;\n          height: 46px;\n          background-color: #212121;\n          z-index: 1;\n          opacity: 0.8;\n          border-radius: 10%;\n          transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n          border: 0;\n        }\n        #frame:hover .lvo-playbtn {\n          background-color: rgb(98, 175, 237);\n          opacity: 1;\n        }\n        /* play button triangle */\n        .lvo-playbtn:before {\n          content: '';\n          border-style: solid;\n          border-width: 11px 0 11px 19px;\n          border-color: transparent transparent transparent #fff;\n        }\n        .lvo-playbtn,\n        .lvo-playbtn:before {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate3d(-50%, -50%, 0);\n        }\n\n        /* Post-click styles */\n        .lvo-activated {\n          cursor: unset;\n        }\n\n        #frame.lvo-activated::before,\n        .lvo-activated .lvo-playbtn {\n          display: none;\n        }\n      </style>\n      <div id=\"frame\">\n        <picture>\n          <source id=\"webpPlaceholder\" type=\"image/webp\">\n          <source id=\"jpegPlaceholder\" type=\"image/jpeg\">\n          <img id=\"fallbackPlaceholder\"\n               referrerpolicy=\"origin\"\n               width=\"1100\"\n               height=\"619\"\n               decoding=\"async\"\n               loading=\"lazy\">\n        </picture>\n        <button class=\"lvo-playbtn\"></button>\n      </div>\n    ";
        this.domRefFrame = this.shadowRoot.querySelector('#frame');
        this.domRefImg = {
          fallback: this.shadowRoot.querySelector('#fallbackPlaceholder'),
          webp: this.shadowRoot.querySelector('#webpPlaceholder'),
          jpeg: this.shadowRoot.querySelector('#jpegPlaceholder')
        };
        this.domRefPlayButton = this.shadowRoot.querySelector('.lvo-playbtn');
      }
      /**
       * Parse our attributes and fire up some placeholders
       */

    }, {
      key: "setupComponent",
      value: function setupComponent() {
        this.initImagePlaceholder();
        this.domRefPlayButton.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
        this.setAttribute('title', "".concat(this.videoPlay, ": ").concat(this.videoTitle));

        if (this.autoLoad) {
          this.initIntersectionObserver();
        }
      }
      /**
       * Lifecycle method that we use to listen for attribute changes to period
       * @param {*} name
       * @param {*} oldVal
       * @param {*} newVal
       */

    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldVal, newVal) {
        switch (name) {
          case 'videoid':
            {
              if (oldVal !== newVal) {
                this.setupComponent(); // if we have a previous iframe, remove it and the activated class

                if (this.domRefFrame.classList.contains('lvo-activated')) {
                  this.domRefFrame.classList.remove('lvo-activated');
                  this.shadowRoot.querySelector('iframe').remove();
                }
              }

              break;
            }

          default:
            break;
        }
      }
      /**
       * Inject the iframe into the component body
       */

    }, {
      key: "addIframe",
      value: function addIframe() {
        if (!this.iframeLoaded) {
          /**
           * Vimeo example embed markup:
           *
           *  <iframe src="https://player.vimeo.com/video/364402896#t=1m3s"
           *    width="640" height="360"
           *    frameborder="0"
           *    allow="autoplay; fullscreen" allowfullscreen>
           *  </iframe>
           */
          // FIXME: add a setting for autoplay
          var apValue = this.autoLoad && this.autoPlay || !this.autoLoad ? "autoplay=1" : "";
          var srcUrl = new URL("/video/".concat(this.videoId, "?").concat(apValue, "&#t=").concat(this.videoStartAt), "https://player.vimeo.com/"); // TODO: construct src value w/ URL constructor

          var iframeHTML = "\n<iframe frameborder=\"0\"\n  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\n  allowfullscreen src=\"".concat(srcUrl, "\"></iframe>");
          this.domRefFrame.insertAdjacentHTML('beforeend', iframeHTML);
          this.domRefFrame.classList.add('lvo-activated');
          this.iframeLoaded = true;
        }
      }
      /**
       * Setup the placeholder image for the component
       */

    }, {
      key: "initImagePlaceholder",
      value: function () {
        var _initImagePlaceholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var apiUrl, apiResponse, tnLarge, imgId, posterUrlWebp, posterUrlJpeg;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // TODO(slightlyoff): TODO: cache API responses
                  // we don't know which image type to preload, so warm the connection
                  LiteVimeoEmbed.addPrefetch('preconnect', 'https://i.vimeocdn.com/'); // API is the video-id based
                  // http://vimeo.com/api/v2/video/364402896.json

                  apiUrl = "https://vimeo.com/api/v2/video/".concat(this.videoId, ".json"); // Now fetch the JSON that locates our placeholder from vimeo's JSON API

                  _context.next = 4;
                  return fetch(apiUrl);

                case 4:
                  _context.next = 6;
                  return _context.sent.json();

                case 6:
                  apiResponse = _context.sent[0];
                  // Extract the image id, e.g. 819916979, from a URL like:
                  // thumbnail_large: "https://i.vimeocdn.com/video/819916979_640.jpg"
                  tnLarge = apiResponse.thumbnail_large;
                  imgId = tnLarge.substr(tnLarge.lastIndexOf("/") + 1).split("_")[0]; // const posterUrlWebp =
                  //    `https://i.ytimg.com/vi_webp/${this.videoId}/hqdefault.webp`;

                  posterUrlWebp = "https://i.vimeocdn.com/video/".concat(imgId, ".webp?mw=1100&mh=619&q=70");
                  posterUrlJpeg = "https://i.vimeocdn.com/video/".concat(imgId, ".jpg?mw=1100&mh=619&q=70");
                  this.domRefImg.webp.srcset = posterUrlWebp;
                  this.domRefImg.jpeg.srcset = posterUrlJpeg;
                  this.domRefImg.fallback.src = posterUrlJpeg;
                  this.domRefImg.fallback.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
                  this.domRefImg.fallback.setAttribute('alt', "".concat(this.videoPlay, ": ").concat(this.videoTitle));

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function initImagePlaceholder() {
          return _initImagePlaceholder.apply(this, arguments);
        }

        return initImagePlaceholder;
      }()
      /**
       * Setup the Intersection Observer to load the iframe when scrolled into view
       */

    }, {
      key: "initIntersectionObserver",
      value: function initIntersectionObserver() {
        var _this3 = this;

        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
          var options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
          };
          var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !_this3.iframeLoaded) {
                LiteVimeoEmbed.warmConnections();

                _this3.addIframe();

                observer.unobserve(_this3);
              }
            });
          }, options);
          observer.observe(this);
        }
      }
      /**
       * Add a <link rel={preload | preconnect} ...> to the head
       * @param {*} kind
       * @param {*} url
       * @param {*} as
       */

    }, {
      key: "videoId",
      get: function get() {
        return encodeURIComponent(this.getAttribute('videoid') || '');
      },
      set: function set(id) {
        this.setAttribute('videoid', id);
      }
    }, {
      key: "videoTitle",
      get: function get() {
        return this.getAttribute('videotitle') || 'Video';
      },
      set: function set(title) {
        this.setAttribute('videotitle', title);
      }
    }, {
      key: "videoPlay",
      get: function get() {
        return this.getAttribute('videoPlay') || 'Play';
      },
      set: function set(name) {
        this.setAttribute('videoPlay', name);
      }
    }, {
      key: "videoStartAt",
      get: function get() {
        return this.getAttribute('videoPlay') || '0s';
      },
      set: function set(time) {
        this.setAttribute('videoPlay', time);
      }
    }, {
      key: "autoLoad",
      get: function get() {
        return this.hasAttribute('autoload');
      },
      set: function set(value) {
        if (value) {
          this.setAttribute('autoload', '');
        } else {
          this.removeAttribute('autoload');
        }
      }
    }, {
      key: "autoPlay",
      get: function get() {
        return this.hasAttribute('autoplay');
      },
      set: function set(value) {
        if (value) {
          this.setAttribute('autoplay', 'autoplay');
        } else {
          this.removeAttribute('autoplay');
        }
      }
    }], [{
      key: "addPrefetch",
      value: function addPrefetch(kind, url, as) {
        var linkElem = document.createElement('link');
        linkElem.rel = kind;
        linkElem.href = url;

        if (as) {
          linkElem.as = as;
        }

        linkElem.crossOrigin = 'true';
        document.head.append(linkElem);
      }
      /**
       * Begin preconnecting to warm up the iframe load Since the embed's netwok
       * requests load within its iframe, preload/prefetch'ing them outside the
       * iframe will only cause double-downloads. So, the best we can do is warm up
       * a few connections to origins that are in the critical path.
       *
       * Maybe `<link rel=preload as=document>` would work, but it's unsupported:
       * http://crbug.com/593267 But TBH, I don't think it'll happen soon with Site
       * Isolation and split caches adding serious complexity.
       */

    }, {
      key: "warmConnections",
      value: function warmConnections() {
        if (LiteVimeoEmbed.preconnected) return; // Host that Vimeo uses to serve JS needed by player

        LiteVimeoEmbed.addPrefetch('preconnect', 'https://f.vimeocdn.com'); // The iframe document comes from player.vimeo.com

        LiteVimeoEmbed.addPrefetch('preconnect', 'https://player.vimeo.com'); // Image for placeholder comes from i.vimeocdn.com

        LiteVimeoEmbed.addPrefetch('preconnect', 'https://i.vimeocdn.com');
        LiteVimeoEmbed.preconnected = true;
      }
    }, {
      key: "observedAttributes",
      get: function get() {
        return ['videoid'];
      }
    }]);

    return LiteVimeoEmbed;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  LiteVimeoEmbed.preconnected = false;
  return LiteVimeoEmbed;
}();

export { LiteVimeoEmbed }; // Register custom element

customElements.define('lite-vimeo', LiteVimeoEmbed);